import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';

const BASE_URL = COMMUNITY_ENDPOINTS.USERS;

export const getAll = (params = {}) =>
  communityHttpClient.get(`${BASE_URL}/`, { params });

export const getByUsername = (username) =>
  communityHttpClient.get(`${BASE_URL}/${username}/`);

export const update = (username, data, config = {}) =>
  communityHttpClient.put(`${BASE_URL}/${username}/`, data, config);

export const partialUpdate = (username, data, config = {}) =>
  communityHttpClient.patch(`${BASE_URL}/${username}/`, data, config);

export const getUserPosts = (username, params = {}) =>
  communityHttpClient.get(`${BASE_URL}/${username}/posts/`, { params });

export const getDashboard = (username) =>
  communityHttpClient.get(`${BASE_URL}/${username}/dashboard/`);

export const follow = (username) =>
  communityHttpClient.post(`${BASE_URL}/${username}/follow/`);

export const unfollow = (username) =>
  communityHttpClient.post(`${BASE_URL}/${username}/unfollow/`);

export const getFollowers = (username, params = {}) =>
  communityHttpClient.get(`${BASE_URL}/${username}/followers/`, { params });

export const getFollowing = (username, params = {}) =>
  communityHttpClient.get(`${BASE_URL}/${username}/following/`, { params });

export const uploadMedia = (file, type = 'avatar', config = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);

  const nextConfig = {
    headers: { 'Content-Type': 'multipart/form-data', ...(config.headers || {}) },
    ...config
  };

  return communityHttpClient.post(`${BASE_URL}/upload-media/`, formData, nextConfig);
};

export const getStats = (params = {}) =>
  communityHttpClient.get(`${BASE_URL}/stats/`, { params });

export const getContributions = (username, params = {}) =>
  communityHttpClient.get(`${BASE_URL}/${username}/contributions/`, { params });

export const getBookmarks = (username, params = {}) =>
  communityHttpClient.get(`${BASE_URL}/${username}/bookmarks/`, { params });

export const deleteAccount = (username, data) =>
  communityHttpClient.post(`${BASE_URL}/${username}/delete-account/`, data);

export const requestEmailChange = (username, newEmail) =>
  communityHttpClient.post(`${BASE_URL}/${username}/request-email-change/`, { new_email: newEmail });

export const resendEmailChangeOTP = (username, newEmail) =>
  communityHttpClient.post(`${BASE_URL}/${username}/resend-email-change-otp/`, { new_email: newEmail });

export const verifyEmailChange = (username, newEmail, otp) =>
  communityHttpClient.post(`${BASE_URL}/${username}/verify-email-change/`, { new_email: newEmail, otp });

export default {
  getAll,
  getByUsername,
  update,
  getUserPosts,
  getDashboard,
  follow,
  unfollow,
  getFollowers,
  getFollowing,
  uploadMedia,
  getStats,
  partialUpdate,
  getContributions,
  getBookmarks,
  deleteAccount,
  requestEmailChange,
  resendEmailChangeOTP,
  verifyEmailChange
};
